var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinksMenuMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 66 66"
    },
    viewBox: "0 0 66 66",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47,1H19c-2.76,0-5,2.24-5,5v54c0,2.76,2.24,5,5,5h28c2.76,0,5-2.24,5-5V6C52,3.24,49.76,1,47,1z M16,11h34v40H16V11z    M16,6c0-1.65,1.35-3,3-3h28c1.65,0,3,1.35,3,3v3H16V6z M50,60c0,1.65-1.35,3-3,3H19c-1.65,0-3-1.35-3-3v-7h34V60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,5H27c-0.55,0-1,0.45-1,1s0.45,1,1,1h12c0.55,0,1-0.45,1-1S39.55,5,39,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,61c1.65,0,3-1.35,3-3s-1.35-3-3-3s-3,1.35-3,3S31.35,61,33,61z M33,57c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1   S32.45,57,33,57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,25h10c0.55,0,1-0.45,1-1V14c0-0.55-0.45-1-1-1H19c-0.55,0-1,0.45-1,1v10C18,24.55,18.45,25,19,25z M20,15h8v8h-8V15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,38V28c0-0.55-0.45-1-1-1H19c-0.55,0-1,0.45-1,1v10c0,0.55,0.45,1,1,1h10C29.55,39,30,38.55,30,38z M28,37h-8v-8h8V37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,14H35c-0.55,0-1,0.45-1,1s0.45,1,1,1h12c0.55,0,1-0.45,1-1S47.55,14,47,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,18H35c-0.55,0-1,0.45-1,1s0.45,1,1,1h12c0.55,0,1-0.45,1-1S47.55,18,47,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,22h-6c-0.55,0-1,0.45-1,1s0.45,1,1,1h6c0.55,0,1-0.45,1-1S47.55,22,47,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,28H35c-0.55,0-1,0.45-1,1s0.45,1,1,1h12c0.55,0,1-0.45,1-1S47.55,28,47,28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,32H35c-0.55,0-1,0.45-1,1s0.45,1,1,1h12c0.55,0,1-0.45,1-1S47.55,32,47,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,36h-6c-0.55,0-1,0.45-1,1s0.45,1,1,1h6c0.55,0,1-0.45,1-1S47.55,36,47,36z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 48,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 48,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 48,
    r: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinksMenuMobile);
export default __webpack_public_path__ + "static/media/linksMenuMobile.5a2a7c8d482615dcbc7272dfb043f091.svg";
export { ForwardRef as ReactComponent };